import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecipientRequestType } from '@/types/vendorVaultTypes';

export type RecipientRequestActionType = 'revoke' | 'resend' | 'archive';

export const recipientRequestActionApi = (
  id: string,
  action: RecipientRequestActionType
): Promise<ApiResponseType<RecipientRequestType>> => authApiService.POST(`/vendor-vault/requests/${id}/${action}/`, {});
